var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39.069,
    height: 82.369,
    viewBox: "0 0 39.069 82.369",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 39.069,
    height: 82.369,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5",
    "data-name": "Groupe 5",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12",
    "data-name": "Trac\\xE9 12",
    d: "M19.535,33.973a75.321,75.321,0,0,0,10.531,17.55c-.695,1.553-1.422,3.079-2.175,4.566-1.04,1.977-2.145,3.967-3.1,5.665-.909,1.545-1.865,3.078-2.844,4.556-.785,1.186-1.594,2.353-2.417,3.49-.83-1.145-1.638-2.312-2.418-3.488-.979-1.48-1.936-3.013-2.845-4.558-.95-1.7-2.055-3.688-3.1-5.665C10.421,54.6,9.694,53.07,9,51.526A75.326,75.326,0,0,0,19.535,33.973M19.536,0A.174.174,0,0,1,19.5,0c-.168,1.818-.226,3.651-.526,5.446-.053.316-.105.634-.16.95a86.437,86.437,0,0,1-1.876,10.368c-.008.042-.018.082-.029.124C13.925,29.107,8.808,40.251.232,49.629a.984.984,0,0,0-.2.442A1.585,1.585,0,0,0,0,50.345a1.185,1.185,0,0,0,.095.395q1.851,4.6,4.07,8.971c1.05,2,2.144,3.975,3.262,5.972q1.488,2.533,3.11,4.985,2.1,3.165,4.42,6.19,1.9,2.478,3.959,4.859c.163.192.345.368.621.652.274-.284.455-.46.621-.652q2.056-2.383,3.957-4.859,2.328-3.023,4.42-6.19,1.622-2.451,3.11-4.985c1.118-2,2.212-3.975,3.262-5.972q2.218-4.372,4.07-8.971a1.155,1.155,0,0,0,.095-.41,1.409,1.409,0,0,0-.032-.258.955.955,0,0,0-.2-.442c-8.579-9.379-13.693-20.522-16.679-32.74-.011-.042-.021-.082-.029-.124A86.437,86.437,0,0,1,20.257,6.4c-.053-.316-.108-.634-.16-.95C19.8,3.654,19.739,1.82,19.57,0a.15.15,0,0,1-.034,0",
    fill: "#d6ad60"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLg);
export default __webpack_public_path__ + "static/media/lg.0e16c93edd3df4ab021522b876ef697c.svg";
export { ForwardRef as ReactComponent };